import React, { useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import useTopicAnalysisTimeline from '../hooks/useTopicAnalysisTimeline';
import TopicTrends from '@op/pages/Summary/TopicTracking/TopicChartInfo/TopicTrends';
import { FilterContext } from '@op/pages/Summary/context';
import '@op/pages/Summary/TopicTracking/TopicChartInfo/index.scss';

interface ITopicChartInfoProps {
  filter: any;
  gameInfo: any;
}

export default function TopicChartInfo({
  filter,
  gameInfo,
}: ITopicChartInfoProps) {
  const {
    blockData,
    barAndLine,
    loading,
    tableInfo,
    indicators,
    setIndicators,
  } = useTopicAnalysisTimeline({ filter });

  const filterContextValue = useMemo(
    () => ({
      topics: { parent: [], children: [], flag: true },
      sentimentType: 'total' as const,
      filter,
      gameInfo,
      topicOneLevel: {},
      topicTwoLevel: {},
      topicTree: {},
      topicLevel: 'L1' as const,
      topicOptions: [],
      transTopic: (topic: string) => topic,
      clickTopicToFeedsFunc: () => {},
      topicList: {},
    }),
    [filter, gameInfo],
  );

  return (
    <CardCommon className="dbo-topic-chart-info">
      <FilterContext.Provider value={filterContextValue}>
        <TopicTrends
          timeline={barAndLine}
          topicLevel="L1"
          tableInfo={tableInfo}
          setIndicators={setIndicators}
          indicators={indicators}
          blockData={blockData}
          loading={loading}
        />
      </FilterContext.Provider>
    </CardCommon>
  );
}
